import { render, staticRenderFns } from "./vacancy-page.vue?vue&type=template&id=27f48dc7&scoped=true"
import script from "./vacancy-page.vue?vue&type=script&lang=js"
export * from "./vacancy-page.vue?vue&type=script&lang=js"
import style0 from "./vacancy-page.vue?vue&type=style&index=0&id=27f48dc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f48dc7",
  null
  
)

export default component.exports